<template>
  <ion-page>
    <ion-menu side="start" content-id="main-content">
      <ion-header>
        <ion-toolbar translucent>
          <ion-title>Door 42</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list>
          <ion-item href="https://www.paypal.com/donate?hosted_button_id=7NJNKNMFSTPF6" target="_blank">
            <ion-icon :icon="cash" slot="start"></ion-icon>
            <ion-label>Spenden</ion-label>
          </ion-item>
          <ion-item href="mailto:moritz@thedoor42.com?subject=Feedback zur App" target="_blank">
            <ion-icon :icon="star" slot="start"></ion-icon>
            <ion-label>Feedback geben</ion-label>
          </ion-item>
          <ion-item @click="stats()">
            <ion-icon :icon="statsChart" slot="start"></ion-icon>
            <ion-label>Statistiken</ion-label>
          </ion-item>
          <ion-item href="/legal">
            <ion-icon :icon="bandage" slot="start"></ion-icon>
            <ion-label>Impressum & Datenschutz</ion-label>
          </ion-item>
          <ion-item @click="logout()">
            <ion-icon :icon="logOut" slot="start"></ion-icon>
            <ion-label>Ausloggen</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ion-menu>
    <div id="main-content" class="ion-page">
      <!-- @todo: header bereich mit avatar und short stats -->
      <ion-header>
        <ion-toolbar>
          <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
          </ion-buttons>
          <ion-title>
            <HomeButton/>
            Door42
          </ion-title>

        </ion-toolbar>

        <!--      <ion-toolbar>-->
        <!--        <ion-title>Subheader</ion-title>-->
        <!--      </ion-toolbar>-->
      </ion-header>
      <ion-content>
        <ion-fab vertical="bottom" horizontal="end" slot="fixed">
          <router-link :to="{name:'NewTask'}" v-slot="{href}">
            <ion-fab-button :href="href">
              <ion-icon :icon="add"></ion-icon>
            </ion-fab-button>
          </router-link>
        </ion-fab>
        <ion-tabs>
          <!-- Tab bar -->
          <ion-tab-bar slot="top">
            <ion-tab-button tab="timeline" :href="router.resolve({name:'Timeline'}).href">
              {{ t('tabs.timeline') }}
            </ion-tab-button>
            <!--          <ion-tab-button tab="goals" :href="router.resolve({name:'Goals'}).href">-->
            <!--            {{ t('tabs.goals') }}-->
            <!--          </ion-tab-button>-->
            <ion-tab-button tab="reviews" :href="router.resolve({name:'Reviews'}).href">
              {{ t('tabs.reviews') }}
            </ion-tab-button>
            <ion-tab-button tab="toolbox" :href="router.resolve({name:'Tools'}).href">
              {{ t('tabs.toolbox') }}
            </ion-tab-button>
          </ion-tab-bar>
        </ion-tabs>
      </ion-content>
    </div>
  </ion-page>


</template>

<i18n>
{
}
</i18n>

<script lang="ts">

import {
  IonContent,
  IonHeader, IonPage, IonTitle, IonToolbar, IonTabs, IonTabBar, IonTabButton, IonButtons,
  IonFab,
  IonFabButton,
  IonIcon,
  IonMenu,
  IonMenuButton,
  IonList,
  IonLabel,
  IonItem
} from '@ionic/vue';
import HomeButton from "@/components/HomeButton.vue";

import {
  add, cash, logOut, statsChart, star,bandage
} from "ionicons/icons";

import {defineComponent} from 'vue';
import {createI18n, useI18n} from "vue-i18n";
import {RouterLink, useRouter} from "vue-router";
import firebase from "firebase";

const translations = {
  "de": {
    "tabs": {
      "timeline": "Timeline",
      "goals": "Goals",
      "reviews": "Reviews",
      "toolbox": "Toolbox"
    }
  }
}
export default defineComponent({
  name: 'Home',
  components: {
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonButtons,
    IonContent,
    IonIcon,
    IonFabButton,
    IonFab,
    RouterLink,
    HomeButton,
    IonMenu,
    IonMenuButton,
    IonList,
    IonLabel,
    IonItem
  },
  methods: {
    goto(path: string) {
      this.router.push(path)
    },
    logout() {
      firebase.auth().signOut().then(r => this.router.push('/'));
    },
    donate() {
      console.log("donate");
    },
    stats() {

      this.router.push({name:'Stats'});
    }
  },
  setup() {

    const router = useRouter();
    const {t, locale} = useI18n({messages: translations})
    return {t, locale, router, add, cash, star, bandage, logOut, statsChart}

  }
});
</script>

<style scoped>

</style>